import { render, staticRenderFns } from "./igt-number-field.vue?vue&type=template&id=513e79e2&scoped=true&"
import script from "./igt-number-field.vue?vue&type=script&lang=js&"
export * from "./igt-number-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e79e2",
  null
  
)

export default component.exports